import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

interface AuthPageFrameProps {
  children: React.ReactNode;
  mode: 'login' | 'signup';
}

const AuthPageFrame: React.FC<AuthPageFrameProps> = ({ children, mode }) => {
  const isSignup = mode === 'signup';

  return (
    <Box
      component="section"
      aria-label={isSignup ? 'Create an A3 account' : 'Sign in to A3'}
      sx={{
        minHeight: { xs: 'calc(100svh - 132px)', md: 'calc(100vh - 176px)' },
        display: 'grid',
        placeItems: 'center',
        px: { xs: 2, sm: 3, md: 4 },
        py: { xs: 3, md: 5 },
        backgroundColor: 'background.default',
        backgroundImage: 'repeating-linear-gradient(135deg, rgba(19, 88, 76, 0.035) 0 1px, transparent 1px 18px)',
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: '100%',
          maxWidth: 1080,
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '0.82fr 1.18fr' },
          overflow: 'hidden',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          boxShadow: '0 24px 64px rgba(17, 48, 44, 0.12)',
          backgroundColor: 'background.paper',
        }}
      >
        <Box
          sx={{
            minHeight: { xs: 170, md: '100%' },
            p: { xs: 3, sm: 4, md: 5 },
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            color: '#f5f8f4',
            backgroundColor: '#174c43',
            backgroundImage: 'linear-gradient(145deg, rgba(224, 166, 74, 0.16), transparent 48%), repeating-linear-gradient(45deg, rgba(255,255,255,0.035) 0 1px, transparent 1px 14px)',
          }}
        >
          <Box>
            <Typography variant="overline" sx={{ color: '#e6bd74', fontWeight: 800, letterSpacing: 1.5 }}>
              A3 LEARNING
            </Typography>
            <Typography
              component="p"
              sx={{ mt: { xs: 1, md: 5 }, mb: 1.5, fontFamily: 'Fraunces, Georgia, serif', fontSize: 36, lineHeight: 1.12, fontWeight: 700 }}
            >
              Learn with purpose.
            </Typography>
            <Typography sx={{ maxWidth: 320, color: 'rgba(245,248,244,0.78)', lineHeight: 1.7 }}>
              {isSignup
                ? 'Create your A3 account to join the learning community.'
                : 'Your A3 learning and research workspace, ready when you are.'}
            </Typography>
          </Box>
          <Typography variant="caption" sx={{ mt: 3, color: 'rgba(245,248,244,0.62)', letterSpacing: 0.8 }}>
            RESEARCH · STUDY · DISCOVERY
          </Typography>
        </Box>
        <Box sx={{ p: { xs: 3, sm: 4, md: 6 }, minWidth: 0 }}>
          {children}
        </Box>
      </Paper>
    </Box>
  );
};

export default AuthPageFrame;
